var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAirCondition = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M30.842 20.353H9.158c-.291 0-.658-2.55-.658-6.17 0-3.617.367-5.168.658-5.168h21.684c.291 0 .658 1.51.658 5.169s-.367 6.169-.658 6.169Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m30.054 20.353-.292-2.884H10.238l-.293 2.883M31.496 13.133H8.503M8.526 15.226h22.948M21.062 22.313V31M23.687 22.313v4.344M17.875 22.313v5.764M15.437 22.313V24"
}))));
export default SvgAirCondition;